import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from '../../../i18n/i18n';
import { useDoneRedirect } from '../../../hooks/useDoneRedirect';
import { useLayoutData } from '../../../hooks/useLayoutContext';
import HostedStatusBlock from '../../../components/hosted/StatusBlock';
import HostedActionRow from '../../../components/hosted/ActionRow';

type Props = {
  onComplete: () => Promise<void>;
  continueInApp: boolean;
};

/** Hosted Ronan always hands the result back by redirecting to the client. */
export default function HostedDoneScreen({ onComplete, continueInApp }: Props) {
  const { t } = useTranslation();
  const { requestType } = useLayoutData();
  const { error, completing, handleManualComplete } = useDoneRedirect(
    onComplete,
    continueInApp,
    'redirect',
  );

  const prefix =
    requestType === 'issuance' ? 'done.issuance' : 'done.disclosure';

  const subtitle = continueInApp
    ? t(`${prefix}.subtitleCloseTab`)
    : error
      ? t('done.redirectFailed')
      : t(`${prefix}.subtitle`);

  return (
    <HostedStatusBlock
      visual={
        <div className="flex items-center justify-center size-10 rounded-full bg-emerald-500">
          <FontAwesomeIcon icon={faCheck} className="size-5 text-white" />
        </div>
      }
      title={t(`${prefix}.title`)}
      subtitle={subtitle}
    >
      {!continueInApp && error && (
        <HostedActionRow
          className="mt-2 w-full"
          primary={{
            label: completing
              ? t('done.redirecting')
              : t('done.completeRedirect'),
            onClick: handleManualComplete,
            loading: completing,
          }}
        />
      )}
    </HostedStatusBlock>
  );
}
